import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDebtLoadList, updateDebtLoadGroup } from "../../redux/actions/debtLoadAction";
import { useModal } from "./hooks/use-modal";
import { permissionsAccess } from "../../helpers/common";
import { debtGroupKeys, renderValueWithUnit } from "./helpers";
import PreciousMetalsLoader from "../PreciousMetals/Loader/PreciousMetalsLoader";
import { ModalFactory } from "./modals/ModalFactory";
import EditIcon from "../../assets/icons/edit.svg";
import "./index.scss";

const DebtToIncomeRatio = () => {
  const dispatch = useDispatch()
  const { debtLoadList, loading } = useSelector(({ debtLoad }) => debtLoad);
  const [data, setData] = useState([]);
  const [state, setState] = useState({
    date: null,
    dateEntered: false
  });
  const { isOpen, modalType, openModal, closeModal } = useModal();

  const handleSave = (entries) => {
    dispatch(updateDebtLoadGroup(modalType, entries.values));
    closeModal();
  };

  const handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.id;

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const changeDate = () => {
    setState(() => ({
      dateEntered: !!state.date,
    }));
    dispatch(getDebtLoadList(state.date))
  };

  useEffect(() => {
    dispatch(getDebtLoadList());
  }, []);

  useEffect(() => {
    if(debtLoadList) setData(debtLoadList)
  }, [debtLoadList]);

  return (
    <div className="content-inner-data-container">
      <div className="content-datatable">
      <div className="content-datatable-header">
          <div className="content-datatable-header-right">
            <div className="action-items">
              <input
                className="input action-item"
                type="date"
                id="date"
                name="date"
                value={state.date}
                onChange={handleChange}
                max="2100-01-01"
              />
              <button className="action-item" onClick={changeDate}>
                Просмотреть
              </button>
            </div>
          </div>
        </div>
        <div className="content-datatable-content">
          <fieldset className="d-flex">
            {loading ? (
              <PreciousMetalsLoader />
            ) : (
              <>
                {data?.length && data.map((purityGroup, index) => {
                  const { name, values } = purityGroup;
                  return (
                    <div key={index} className="content-card debt-group-card">
                      <div className="content-card-title">
                        <h3>{debtGroupKeys[name]}</h3>
                        {permissionsAccess("action.purities.update") && (
                          <div className="content-card-title-actions">
                            <button
                              className={
                                (state.dateEntered ? 'button-icontrigger-disabled' : '') +
                                ' button-icontrigger caption noborder'
                              }
                              onClick={() => !state.dateEntered && openModal(name, values)}
                            >
                              <span className="icon">
                                <EditIcon />
                              </span>
                              <span>Редактировать</span>
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="content-card-content">
                        {values?.map(({ name, value, dataType }, index) => {
                          return (
                            <div
                              key={index}
                              className="form-element inline flex-space-between"
                            >
                              <label className="form-element-label">
                                {name}
                              </label>
                              <div className="form-element-data">
                                <div className="form-element-data-text">
                                  <p>{value.toFixed(2) || ''} {dataType}</p>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </fieldset>
          {isOpen && (
            <ModalFactory
              type={modalType}
              data={data.find((item) => item.name === modalType)}
              onClose={closeModal}
              onSave={handleSave}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DebtToIncomeRatio;
